module.exports = "/to_the_arctic_for_practice/_next/static/videos/15-4072f998b00f862685ad6cc70c33316c.mp4";